import InputRow from './InputRow';
export type { InputRowProps } from './InputRow.types';

export default InputRow;
